import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import { isResourceLoading } from './common';

const isStatesLoading = lruMemoize(isResourceLoading);
const getStates = lruMemoize(
    (data) => data.getIn(['states'], List()),
);

export {
    isStatesLoading,
    getStates,
};
